import { FilterOperators } from '@opengov/reporting-types';

export const allFilterOptions: ReadonlyArray<{ id: FilterOperators; label: string }> = [
  { id: FilterOperators.Equal, label: 'Equals' },
  { id: FilterOperators.NotEqual, label: 'Does not equal' },
  { id: FilterOperators.Greater, label: 'Greater than or equal to' },
  { id: FilterOperators.Lesser, label: 'Less than or equal to' },
  { id: FilterOperators.Contain, label: 'Contains' },
  { id: FilterOperators.NotContain, label: 'Does not contain' },
  { id: FilterOperators.Begin, label: 'Begins with' },
  { id: FilterOperators.End, label: 'Ends with' },
  { id: FilterOperators.Blank, label: 'Is empty' },
  { id: FilterOperators.NotBlank, label: 'Is not empty' }
];

export const textFilterOptions: ReadonlyArray<{ id: FilterOperators; label: string }> = [
  { id: FilterOperators.Equal, label: 'Equals' },
  { id: FilterOperators.NotEqual, label: 'Does not equal' },
  { id: FilterOperators.Contain, label: 'Contains' },
  { id: FilterOperators.NotContain, label: 'Does not contain' },
  { id: FilterOperators.Begin, label: 'Begins with' },
  { id: FilterOperators.End, label: 'Ends with' },
  { id: FilterOperators.Blank, label: 'Is empty' },
  { id: FilterOperators.NotBlank, label: 'Is not empty' }
];
